<template>
  <div class="favorite-gallery">
    <div
      class="favorite-gallery__item"
      v-for="item of products"
      :key="item.id"
    >
      <product-list-item
        :product="item"
        favorite-size-selector
      />
    </div>

    <div
      v-if="!isEnd"
      v-reached="onLoad"
      class="favorite-gallery__loader"
    >
      <transition name="fade">
        <ui-loader
          v-if="isLoading"
          size="60"
        />
      </transition>
    </div>
  </div>
</template>

<script>
import ProductListItem from '@/components/catalog/product-list-item.vue';

export default {
  name: 'favorite-gallery',

  components: {
    ProductListItem,
  },

  props: {
    products: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    isEnd: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    onLoad() {
      this.$emit('load');
    }
  }
};
</script>

<style lang="scss">
.favorite-gallery {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 16px;
  row-gap: 32px;

  @include breakpoint("tablet") {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }

  @include breakpoint("desktop") {
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 24px;
    row-gap: 48px;
  }

  &__loader {
    display: flex;
    justify-content: center;
    grid-column: 1 / 3;
    color: $blue;

    @include breakpoint("tablet") {
      grid-column: 1 / 5;
    }

    @include breakpoint("desktop") {
      grid-column: 1 / 4;
    }
  }
}
</style>
